import styled from "styled-components";
import { secondaryThemeColor } from "../../assets/theme";

export const Container = styled.div`
    max-width: 900px;
    margin: 0 auto;
    padding: 2em;
    line-height: 1.7;
`;

export const Title = styled.h1`
    font-size: 2.5rem;
    text-align: center;
    margin-bottom: 0.5em;
`;

export const QuickLinks = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 1em;
    margin-bottom: 2.5em;
`;

export const QuickLink = styled.a`
    padding: 0.5em 1em;
    background: ${secondaryThemeColor};
    color: white;
    border-radius: 6px;
    text-decoration: none;
    font-size: 0.9rem;
    transition: opacity 0.2s ease;

    &:hover {
        opacity: 0.85;
    }
`;

export const TOC = styled.div`
    padding: 1.5em 2em;
    margin-bottom: 2em;
    border-left: 4px solid ${secondaryThemeColor};
`;

export const TOCTitle = styled.h4`
    margin: 0 0 1em;
    font-size: 1.1rem;
`;

export const TOCList = styled.ul`
    margin: 0;
    padding-left: 1.5em;

    li {
        margin: 0.5em 0;
    }

    ul {
        margin: 0.25em 0;
        padding-left: 1.5em;
    }
`;

export const Section = styled.section`
    margin: 2.5em 0;
`;

export const SectionTitle = styled.h2`
    font-size: 1.8rem;
    border-bottom: 2px solid ${secondaryThemeColor};
    padding-bottom: 0.3em;
    margin-bottom: 1em;
`;

export const SubSection = styled.div`
    margin: 1.5em 0;
`;

export const SubTitle = styled.h3`
    font-size: 1.3rem;
    margin-bottom: 0.75em;
`;

export const Paragraph = styled.p`
    margin: 1em 0;
    text-align: justify;
`;

export const List = styled.ul`
    margin: 1em 0;
    padding-left: 1.5em;

    li {
        margin: 0.5em 0;
    }
`;

export const Link = styled.a`
    color: ${secondaryThemeColor};
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
`;

export const TOCLink = styled.span`
    color: ${secondaryThemeColor};
    cursor: pointer;
    text-decoration: underline;
    text-decoration-style: dotted;
    text-underline-offset: 3px;

    &:hover {
        text-decoration-style: solid;
    }
`;

export const Code = styled.code`
    background: rgba(128, 128, 128, 0.15);
    padding: 0.2em 0.4em;
    border-radius: 4px;
    font-family: "Courier New", monospace;
    font-size: 0.9em;
`;

export const CodeBlock = styled.pre`
    background: #2b2b2b;
    color: #f8f8f2;
    padding: 1em 1.5em;
    border-radius: 8px;
    overflow-x: auto;
    font-family: "Courier New", monospace;
    font-size: 0.9em;
    line-height: 1.5;
    margin: 1em 0;
`;

export const Note = styled.div`
    background: rgba(255, 152, 0, 0.1);
    border-left: 4px solid #ff9800;
    padding: 1em 1.5em;
    margin: 1.5em 0;
    border-radius: 0 8px 8px 0;

    strong {
        color: #ff9800;
    }
`;
